import Breadcrumbs from "@/components/Breadcrumbs";
import { SettingsService } from "@/services/admin-services";
import { SettingsDiscipline } from "@/services/admin-services/models";
import {
    Box,
    Button,
    CircularProgress,
    Divider,
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const breadcrumbs = [
    {
        to: "../..",
        title: "Administration",
    },
    {
        title: "Settings",
        to: "../..",
    },
    {
        title: "Disciplines",
        to: "",
    },
];

const Overview = () => {
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [data, setData] = useState<Array<SettingsDiscipline>>([]);

    const settingsService = new SettingsService("int");

    const navigate = useNavigate();

    useEffect(() => {
        settingsService.getDisciplines().then((data) => {
            setData(data);
            setIsLoading(false);
        });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Box>
            <Breadcrumbs trail={breadcrumbs} />

            <Divider />

            <Grid container spacing={2} p={{ xs: 2, md: 4 }}>
                <Grid size={{ xs: 12, md: 12 }}>
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 750 }} aria-label="simple table">
                            <TableHead sx={{ bgcolor: "alternate.main" }}>
                                <TableRow>
                                    <TableCell>
                                        <Typography
                                            color={"text.secondary"}
                                            variant={"caption"}
                                            fontWeight={700}
                                            sx={{ textTransform: "uppercase" }}
                                        >
                                            Discipline
                                        </Typography>
                                    </TableCell>
                                    <TableCell width={100}>
                                        <Typography
                                            color={"text.secondary"}
                                            variant={"caption"}
                                            fontWeight={700}
                                            sx={{ textTransform: "uppercase" }}
                                        >
                                            Order
                                        </Typography>
                                    </TableCell>
                                    <TableCell sx={{ width: 100 }} />
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {isLoading ? (
                                    <TableRow>
                                        <TableCell
                                            colSpan={3}
                                            sx={{
                                                height: 400,
                                                alignItems: "center",
                                                flexDirection: "column",
                                            }}
                                        >
                                            <Box sx={{ display: "flex", placeContent: "center" }}>
                                                <CircularProgress />
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    data
                                        .sort((a, b) => a.order - b.order)
                                        .map((item, i) => (
                                            <TableRow
                                                key={i}
                                                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                            >
                                                <TableCell component="th" scope="row">
                                                    <Typography color={"text.secondary"} variant={"subtitle2"}>
                                                        {item.code}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell scope="row">
                                                    <Typography color={"text.secondary"} variant={"subtitle2"}>
                                                        {item.order}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell scope="row" sx={{ p: 0 }}>
                                                    <Box sx={{ display: "flex" }}>
                                                        <Button
                                                            color={"primary"}
                                                            sx={{ ml: "auto", mr: 1 }}
                                                            onClick={() =>
                                                                navigate(`/admin/settings/disciplines/${item.id}`)
                                                            }
                                                        >
                                                            View
                                                        </Button>
                                                    </Box>
                                                </TableCell>
                                            </TableRow>
                                        ))
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>
        </Box>
    );
};

export default Overview;
